/**
 * layout.js — Shared Navigation & Footer Injector
 * Dynamically injects the navbar and footer into subpages.
 * Home (index.html) has its own inline nav/footer, so this
 * is used only by services.html, about.html, process.html, contact.html.
 */

/**
 * Determines the correct path prefix based on current page depth.
 * All pages are at root level, so paths are relative to root.
 */
function getBasePath() {
  return './';
}

/**
 * Returns the current page filename for active-nav highlighting.
 */
function getCurrentPage() {
  const path = window.location.pathname;
  const file = path.split('/').pop() || 'index.html';
  return file;
}

/**
 * Injects the shared navigation bar.
 */
export function injectNav() {
  const navTarget = document.getElementById('shared-nav');
  if (!navTarget) return;

  const currentPage = getCurrentPage();
  const base = getBasePath();

  const isActive = (page) => currentPage === page ? 'active' : '';

  navTarget.innerHTML = `
    <nav>
      <a href="${base}index.html" class="nav-logo">
        <img src="${base}src/assets/logo.png" alt="Razaek Technologies" onerror="this.style.display='none';this.nextElementSibling.style.display='block'">
        <span style="display:none;font-family:var(--font);font-weight:800;font-size:20px;background:var(--grad);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;">Razaek</span>
      </a>
      <ul class="nav-links">
        <li><a href="${base}services.html" class="${isActive('services.html')}">Services</a></li>
        <li><a href="${base}about.html" class="${isActive('about.html')}">Why Us</a></li>
        <li><a href="${base}process.html" class="${isActive('process.html')}">Process</a></li>
        <li><a href="${base}contact.html" class="nav-cta ${isActive('contact.html')}">Get Free Quote</a></li>
      </ul>
      <button class="nav-hamburger" aria-label="Toggle menu">
        <span></span><span></span><span></span>
      </button>
    </nav>
  `;

  // Mobile menu toggle
  const hamburger = navTarget.querySelector('.nav-hamburger');
  const navLinks = navTarget.querySelector('.nav-links');
  if (hamburger && navLinks) {
    hamburger.addEventListener('click', () => {
      navLinks.classList.toggle('nav-open');
      hamburger.classList.toggle('nav-active');
    });

    // Close menu when a link is clicked
    navLinks.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        navLinks.classList.remove('nav-open');
        hamburger.classList.remove('nav-active');
      });
    });
  }
}

/**
 * Injects the shared footer.
 */
export function injectFooter() {
  const footerTarget = document.getElementById('shared-footer');
  if (!footerTarget) return;

  const base = getBasePath();

  footerTarget.innerHTML = `
    <footer>
      <div class="footer-top">
        <div>
          <div class="footer-logo">
            <img src="${base}src/assets/logo.png" alt="Razaek Technologies" onerror="this.style.display='none'">
          </div>
          <p class="footer-desc">Your digital growth partner — logos, websites, apps, and marketing all under one roof.</p>
        </div>
        <div class="footer-col">
          <h5>Services</h5>
          <ul>
            <li><a href="${base}services.html">Logo & Branding</a></li>
            <li><a href="${base}services.html">UI/UX Design</a></li>
            <li><a href="${base}services.html">Web Development</a></li>
            <li><a href="${base}services.html">App Development</a></li>
            <li><a href="${base}services.html">Digital Marketing</a></li>
          </ul>
        </div>
        <div class="footer-col">
          <h5>Company</h5>
          <ul>
            <li><a href="${base}about.html">About Us</a></li>
            <li><a href="${base}process.html">Our Process</a></li>
            <li><a href="${base}contact.html">Contact</a></li>
          </ul>
        </div>
        <div class="footer-col">
          <h5>Contact</h5>
          <ul>
            <li><a href="https://wa.me/919999999999" target="_blank">WhatsApp</a></li>
            <li><a href="mailto:hello@razaektechnologies.com">Email Us</a></li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <p>© ${new Date().getFullYear()} Razaek Technologies. All rights reserved.</p>
        <div class="footer-socials">
          <a href="#" title="Instagram">📸</a>
          <a href="#" title="LinkedIn">💼</a>
          <a href="#" title="WhatsApp">💬</a>
        </div>
      </div>
    </footer>
  `;
}
